import LoginLayout from '../../../layouts/LoginLayout'
import ResetPassword from './ResetPassword'

export default LoginLayout(ResetPassword)